// extracted by mini-css-extract-plugin
export default {"countryContainer":"Country_countryContainer__Vvewj","img":"Country_img__J1cT1","cases":"Country_cases__bYAGf","icon":"Country_icon__qd54e"};